module.exports = __webpack_public_path__ + "static/media/new-logo.67b4b987.png";